import React from 'react'
import { WidgetContent } from '@duik/it'
import CreateNewModal from '../../UI/CreateNewModal'
import { ModalButton } from '../../UI/ModalButton'

const RemoveTruck = ({ replaceDriver, setCancelledNotes, cancelledNotes, handleCloseModal }) => {
  const handleSaveButtonClick = () => {
    replaceDriver()
  }

  return (
    <CreateNewModal
      title="Remove Truck"
      bannerText="Add an optional note to drivers and dispatchers"
      handleCloseModal={handleCloseModal}
    >
      <WidgetContent
        style={{
          height: 'auto',
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          padding: 0,
          overflowY: 'scroll',
          overflowX: 'hidden'
        }}
        id="dispatch-form"
      >
        <div style={{ paddingTop: '26px', display: 'flex', flexDirection: 'column' }}>
          <div style={{ paddingBottom: '8px', display: 'flex', justifyContent: 'space-between' }}>
            <span style={{ fontSize: '12px', color: '#9EA0A5' }}>NOTE</span>
            <span style={{ fontSize: '12px', color: '#9EA0A5' }}>(optional)</span>
          </div>
          <textarea
            className="fullWidthInputBox uik-input__input"
            label="Notes"
            name="notes"
            style={{
              height: '285px',
              resize: 'none',
              padding: '16px',
              border: '1px solid #eaedf3'
            }}
            value={cancelledNotes}
            onChange={e => setCancelledNotes(e.target.value)}
          />
        </div>
      </WidgetContent>
      <div style={{ display: 'flex' }}>
        <WidgetContent
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            border: 'none',
            width: '482px'
          }}
        >
          <div style={{ width: '83px' }}>
            <ModalButton
              success
              backgroundcolor="#38B249"
              // disabled={isSubmitting}
              name="Ok"
              onClick={handleSaveButtonClick}
            />
          </div>
        </WidgetContent>
      </div>
    </CreateNewModal>
  )
}

export default RemoveTruck
